if (!customElements.get("klaviyo-custom-trigger")) {
  class KlaviyoCustomTrigger extends HTMLElement {
    constructor() {
      super();
    }

    get formId() {
      return this.getAttribute("form-id");
    }

    connectedCallback() {
      this.addEventListener("click", this.onClickListener.bind(this));
      this.addEventListener("keydown", this.onKeydownListener.bind(this));
    }

    openKlaviyoForm() {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push([
        "openForm",
        this.formId.toString()
      ]);
    }

    onClickListener() {
      this.openKlaviyoForm();
    }

    onKeydownListener(event) {
      if (event.key === "Enter") {
        this.openKlaviyoForm();
      }
    }
  }

  customElements.define("klaviyo-custom-trigger", KlaviyoCustomTrigger);
}
